import { useEffect, useRef } from "react";
import { Header } from "../components/Header";
import { SettingsCard } from "../components/settings/SettingsCard";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./ProfilePage.module.css";

export function SettingsPage() {
	const { t, direction } = useClientTranslations("profile");
	const { logProfile } = useAnalytics();
	const hasInitialized = useRef(false);

	useEffect(() => {
		if (!hasInitialized.current) {
			hasInitialized.current = true;
			logProfile("settings_page_viewed");
		}
	}, [logProfile]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main} dir={direction}>
				<div className={styles.container}>
					<div className={styles.heading}>
						<h1 className={styles.title}>{t("settings.title")}</h1>
						<p className={styles.subtitle}>{t("settings.subtitle")}</p>
					</div>
					<div className={styles.sections}>
						<SettingsCard
							label={t("settings.cards.subscription")}
							to="/settings/subscription"
						/>
						<SettingsCard
							label={t("settings.cards.security")}
							to="/settings/security"
						/>
						<SettingsCard
							label={t("settings.cards.support")}
							to="/settings/support"
						/>
					</div>
				</div>
			</main>
		</div>
	);
}
